import PropTypes from 'prop-types';

export const LoyaltyPointDefaultProps = {
  loyalty_point: {},
};
export const LoyaltyPointPropTypes = {
  loyalty_point: PropTypes.shape({
    loyalty_points: PropTypes.number,
    discount_loyalty_points: PropTypes.number,
  }),
};
